<div class="w-full max-w-none mx-auto">
  <!-- Header -->
  <div class="px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
    <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
      {{ Userheadername }}
    </h3>
    <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <button
        *ngIf="mode"
        class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
        (click)="back()"
      >
        Back
      </button>
      <div *ngIf="mode" class="flex items-center text-sm text-gray-600 dark:text-gray-400">
        <ng-icon name="heroComputerDesktop" class="text-lg mr-2"></ng-icon> 
        <span class="hidden sm:inline">For Multi select please hold the <b>Ctrl</b> key</span>
        <span class="sm:hidden">Hold <b>Ctrl</b> for multi-select</span>
      </div>
    </div>
  </div>
  <!-- Card Body -->
  <div class="p-4 sm:p-6 overflow-hidden">
    <div class="w-full overflow-x-auto" *ngIf="!mode">
      <kendo-grid
        [kendoGridBinding]="userlist"
        (selectionChange)="onSelect($event)"
        [selectable]="true"
        [groupable]="false"
        [pageable]="{
          buttonCount: 5,
          info: true,
          type: 'numeric',
          pageSizes: [10, 20, 50, 100],
          previousNext: true
        }"
        [pageSize]="10"
        [filterable]="true"
        [sortable]="{ allowUnsort: true, mode: 'single' }"
        [sort]="sort"
        (sortChange)="sortChange($event)"
        class="min-w-full"
      >
        <ng-template kendoGridToolbarTemplate>
          <button
            type="button"
            class="excelbtn bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
            kendoGridExcelCommand
            icon="file-excel"
          >
            Export to Excel
          </button>
        </ng-template>
        <kendo-grid-column field="userName" title="UserName" [width]="150"> </kendo-grid-column>
        <kendo-grid-column field="email" title="Email" [width]="200"> </kendo-grid-column>
        <kendo-grid-column field="firstName" title="First Name" [width]="150">
        </kendo-grid-column>
        <kendo-grid-column field="lastName" title="Last Name" [width]="150">
        </kendo-grid-column>
        <kendo-grid-excel fileName="userlist.xlsx" [fetchData]="allData"></kendo-grid-excel>
      </kendo-grid>
    </div>
    <!-- Edit User Component -->
    <div *ngIf="mode" class="w-full overflow-hidden">
      <gd--edituser
        (updateuser)="back()"
        [userout]="userSelected"
        [getrolelist]="rolelist"
        [productTypelist]="productTypelist"
        [emailTypelist]="emailTypelist"
      ></gd--edituser>
    </div>
  </div>
</div>
